const trangThaiTTOptions = [
  {
    value: 0,
    label: "Chưa thanh toán",
    code: "CTT",
  },
  {
    value: 1,
    label: "Đã thanh toán",
    code: "DTT",
  },
  {
    value: 2,
    label: "Hủy thanh toán",
    code: "HTT",
  },
  {
    value: 3,
    lable: "Đã tạm ứng",
    code: "DTU"
  }
];

const trangThaiOptions = [
  {value: 0, label: "Phiếu khám mới", code: "PKM"},
  {value: 1, label: "Chờ thực hiện", code: "CTH"},
  {value: 2, label: "Đang thực hiện", code: "ĐTH"},
  {value: 3, label: "Hoàn thành", code: "HT"},
  {value: 4, label: "Chờ kết quả xét nghiệm", code: "CKQXN"},
  {value: 5, label: "Đã có kết quả xét nghiệm", code: "DKQXN"},
  {value: 6, label: "Hủy hiện thực", code: "HTH"},
  {value: 7, label: "Đã xóa", code: "DEL"},
];

const loaiKCBNT = [
  {value: 0, label: "Thông thường"},
  {value: 1, label: "Cấp cứu"},
  {value: 2, label: "Tái khám thông thường"},
  {value: 3, label: "Tái khám sau phẫu thuật"},
  {value: 4, label: "Hẹn phẫu thuật"},
  {value: 5, label: "Khám đo kính"},
  {value: 6, label: "Định kỳ"},
  {value: 7, label: "Khác"},
];
const trangThaiTraThuocOptions = [
  {
    id: 0,
    tenTTTraThuoc: "Không tra",
  },
  {
    id: 1,
    tenTTTraThuoc: "Đã thực hiện, Chờ hết thuốc",
  },
  {
    id: 2,
    tenTTTraThuoc: "Đã thực hiện, Hết thời gian chờ",
  },
];
const loaiBNOptions = [
  {value: 0, label: "Cấp cứu"},
  {value: 1, label: "Trẻ em dưới 4 tuổi"},
  {value: 2, label: "Người khuyết tật"},
  {value: 3, label: "Người cao tuổi"},
  {value: 4, label: "Phụ nữ có thai"},
  {value: 5, label: "VIP"}
]
export {
  trangThaiTTOptions,
  trangThaiTraThuocOptions,
  trangThaiOptions,
  loaiKCBNT,
  loaiBNOptions
};
